import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import Toasted from "vue-toasted";
import VTooltip from "v-tooltip";
import "./assets/tooltip.css";
import VueApexCharts from "vue-apexcharts";
import VueSignaturePad from "vue-signature-pad";

import moment from "moment";
import MomentTimezone from "moment-timezone";
// import AudioVisual from 'vue-audio-visual'
import VueCardFormat from "vue-credit-card-validation";
import infiniteScroll from "vue-infinite-scroll";

import "../src/design/app.scss";

import store from "@/state/store";
// import { socketConnect } from "./helpers/webSocketHandler";

import App from "./App.vue";

import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import VueDragscroll from "vue-dragscroll";
import SmartTable from "vuejs-smart-table";

import tinymce from "vue-tinymce-editor";

import OtpInput from "@bachdgvn/vue-otp-input";

import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    global_format_date: (date) =>
      moment(date).format(
        store.state.auth.hotel
          ? store.state.auth.hotel.date_format
          : "YYYY-MM-DD"
      ),
    global_format_time: (date) =>
      moment(date).format(
        store.state.auth.hotel ? store.state.auth.hotel.time_format : "HH:mm"
      ),
    global_format_date_and_time: (date) => {
      return moment(date).format(
        store.state.auth.hotel
          ? store.state.auth.hotel.date_time_format
            ? store.state.auth.hotel.date_time_format
            : "YYYY-MM-DD HH:mm"
          : "YYYY-MM-DD HH:mm"
      );
    },
    global_format_date_and_time_custom: (date, date_formate) => {
      return moment(date).format(date_formate);
    },
  },
});
if (store.state.auth.hotel !== null) {
  // const messageConnection = socketConnect(
  //   `msg/${store.state.auth.hotel.id}?token=${store.state.auth.user.access}`
  // );
  Vue.prototype.$messsageSocketConnection = "";
  MomentTimezone.tz.setDefault(store.state.auth.hotel.time_zone);
}
Vue.component("vue-simple-context-menu", VueSimpleContextMenu);
Vue.component("v-otp-input", OtpInput);
Vue.component("tinymce", tinymce);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueTelInput);
Vue.use(VueDragscroll);
Vue.use(VueCardFormat);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
// Vue.use(AudioVisual)
Vue.use(SmartTable);

const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.use(infiniteScroll);
Vue.use(VTooltip);
Vue.use(require("vue-chartist"));
Vue.use(VueSignaturePad);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(Toasted);
Vue.use(moment);
Vue.use(MomentTimezone);

export const EventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
